<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="device-log">
      <div class="device-log-top">
        <p class="device-log-top-title">操作日志</p>
        <img
          class="device-log-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="device-log-middle">
        <div class="log-list" ref="logList">
          <div 
            v-for="(item, index) in logArray" 
            :key="index" 
            class="log-item"
          >
            <div class="log-row">
              <span class="log-label">操作人：</span>
              <span class="log-value">{{ placeholderText(item.operatorName) }}</span>
            </div>
            <div class="log-row">
              <span class="log-label">操作时间：</span>
              <span class="log-value">{{ formatOperationTime(item.operationTime) }}</span>
            </div>
            <div class="log-row content-row">
              <span class="log-label">操作内容：</span>
              <span class="log-value">{{ placeholderText(item.operationContent) }}</span>
            </div>
          </div>
          <div v-if="logArray.length === 0" class="log-empty">
            暂无操作日志
          </div>
        </div>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import { DateTool } from "@js/date-tool.js";

export default {
  components: {
    PopView,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    targetType: {
      type: String,
      default: "device_archive"
    }
  },

  data: function () {
    return {
      logArray: [],
    };
  },

  async mounted() {
    this.logListRequest();
  },

  methods: {
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    // 数据格式化方法
    placeholderText(rawValue) {
      if (!rawValue || rawValue === "null") {
        return "-";
      }
      return rawValue;
    },

    formatOperationTime(operationTime) {
      return this.placeholderText(
        DateTool.formatDate(
          DateTool.strToDate(operationTime),
          "Y-M-D h:m:s"
        )
      );
    },

    // 接口请求方法
    async logListRequest() {
      try {
        const params = {
          targetId: this.deviceData.id,
          pageNum: 1,
          pageSize: 100,
          targetType: this.targetType,
        };
        
        // 调用getSleepOperationLogs接口获取操作日志
        const response = await this.$api.getSleepOperationLogs(params);
        this.logArray = response.list || [];
      } catch (error) {
        console.error('获取操作日志失败:', error);
        this.$toast.showRed("获取操作日志失败");
        // 错误时显示空数据
        this.logArray = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.device-log {
  width: rem(700);
  height: rem(650);
  overflow-y: scroll;
  margin-bottom: rem(20);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
      margin: 0;
    }

    &-close {
      width: rem(16);
      height: rem(16);
      cursor: pointer;
    }
  }

  &-middle {
    width: 100%;
    height: calc(100% - rem(55));
    padding: rem(20) rem(24);
    box-sizing: border-box;
    overflow: hidden;

    .log-list {
      height: 100%;
      overflow-y: scroll;
      background-color: white;
      border: rem(1) solid #e8e8e8;
      border-radius: rem(4);
      
      .log-item {
        padding: rem(16) rem(20);
        border-bottom: rem(1) solid #f0f0f0;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: #fafafa;
        }
        
        &:last-child {
          border-bottom: none;
        }
        
        .log-row {
          display: flex;
          margin-bottom: rem(8);
          font-size: rem(14);
          line-height: rem(20);
          
          &:last-child {
            margin-bottom: 0;
          }
          
          &.content-row {
            align-items: flex-start;
            
            .log-value {
              word-break: break-all;
              white-space: normal;
            }
          }
          
          .log-label {
            color: rgba(0, 0, 0, 0.65);
            font-weight: normal;
            width: rem(80);
            flex-shrink: 0;
            text-align: right;
            margin-right: rem(12);
          }
          
          .log-value {
            color: rgba(0, 0, 0, 0.85);
            flex: 1;
          }
        }
      }
      
      .log-empty {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        font-size: rem(14);
        min-height: rem(200);
      }
    }
  }

}
</style>